import { Box, Button } from '@mui/material';
import { useEffect, useState } from 'react';

const originalSlides = [
  // {
  //   text: (
  //     <>
  //       <span style={{ fontWeight: 'bold', color: '#f2ff35' }}>
  //         📢 Missed the May 15 deadline?
  //       </span>{' '}
  //       E-file your{' '}
  //       <span style={{ fontWeight: 600, color: '#e2ff79' }}>
  //         2025 Form 990 series
  //       </span>{' '}
  //       tax return now — before it’s too late!
  //     </>
  //   ),
  //   buttonText: 'E-File Now',
  //   link: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=homebanner`,
  // },
  {
    text: (
      <>
        <span style={{ fontWeight: 'bold', color: '#f2ff35' }}>
          📢 Attention Employers!
        </span>{' '}
        E-file{' '}
        <span style={{ fontWeight: 600, color: '#ffffff' }}>
          Form 941 (Q3-2026)
        </span>{' '}
        Today to Report Your{' '}
        <span style={{ fontWeight: 600, color: '#ffffff' }}>
          Quarterly Payroll Taxes
        </span>
        .{' '}
      </>
    ),
    buttonText: 'E-File Now',
    link: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=homebanner`,
  },
  // {
  //   text: (
  //     <>
  //       <span style={{ fontWeight: 'bold', color: '#f2ff35' }}>
  //         📢 It’s the final day!
  //       </span>{' '}
  //       E-file{' '}
  //       <span style={{ fontWeight: 600, color: '#e2ff79' }}>
  //         Form 941 (Q2-2026)
  //       </span>{' '}
  //       Now to Avoid IRS Penalties.
  //     </>
  //   ),
  //   buttonText: 'E-File Now',
  //   link: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=homebanner`,
  // },
];

const slides = [...originalSlides, ...originalSlides, ...originalSlides];

export default function SimpleCarousel() {
  const [index, setIndex] = useState(originalSlides.length);
  const [animated, setAnimated] = useState(true);
  // const resetting = useRef(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => prev + 1);
    }, 8000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;

    if (index >= slides.length - originalSlides.length) {
      timer = setTimeout(() => {
        setAnimated(false);
        setIndex(originalSlides.length);
      });
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [index]);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;

    if (!animated) {
      timer = setTimeout(() => {
        setAnimated(true);
      }, 50);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [animated]);

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: { xs: 0, sm: 0 },
        minHeight: { xs: 50, sm: 60, md: 40 },
        maxWidth: '100%',
      }}
    >
      {/* <IconButton
        type="button"
        aria-label="Previous slide"
        aria-controls="home-banner-carousel"
        title="Previous slide"
        onClick={() => {
          if (!resetting.current) {
            setIndex((prev) => prev - 1);
          }
        }}
      >
        <ExpandCircleDownIcon
          aria-hidden="true"
          sx={{
            color: '#caebff',
            transform: 'rotate(90deg)',
          }}
        />
      </IconButton> */}

      {/* <Box
        sx={{
          width: '100%',
          maxWidth: { xs: '100%', md: '1100px' },
          mx: 'auto',
          overflow: 'hidden',
        }}
      > */}
      <Box
        id="home-banner-carousel"
        role="region"
        aria-label="Tax filing announcements carousel"
        sx={{
          display: 'flex',
          width: '100%',
          transform: `translateX(-${index * 100}%)`,
          transition: animated ? 'transform 0.8s ease' : 'none',
        }}
      >
        {slides.map((item, i) => (
          <Box
            key={i}
            sx={{
              minWidth: '100%',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: 'center',
              gap: { xs: 1, sm: 2 },
              color: '#e5e5e5',
            }}
          >
            <Box
              sx={{
                color: '#dcdcdc',
                fontSize: { xs: 13, sm: 14, md: 16.2 },
                textAlign: 'center',
              }}
            >
              {item.text}
            </Box>

            <Button
              href={item.link}
              variant="contained"
              color="primary"
              size="small"
              sx={{
                backgroundColor: '#fff',
                color: '#2c5257',
                borderRadius: 3,
                textTransform: 'none',
                whiteSpace: 'nowrap',
                boxShadow: 'none',
                px: { xs: 1.5, sm: 2 },
                '&:hover': {
                  backgroundColor: '#172b6b',
                  color: '#fff',
                },
              }}
            >
              {item.buttonText}
            </Button>
          </Box>
        ))}
      </Box>
      {/* </Box> */}

      {/* <IconButton
        type="button"
        aria-label="Next slide"
        aria-controls="home-banner-carousel"
        title="Next slide"
        onClick={() => {
          if (!resetting.current) {
            setIndex((prev) => prev + 1);
          }
        }}
      >
        <ExpandCircleDownIcon
          aria-hidden="true"
          sx={{
            color: '#caebff',
            transform: 'rotate(-90deg)',
          }}
        />
      </IconButton> */}
    </Box>
  );
}
